// base
import { forwardRef, useMemo } from 'react';

// modules
import { TABLE_EMPTY_DATA } from 'constants/const';
import { IUser, useGetNationList } from 'modules';

// style
import { nfcCardIcons } from 'constants/images';
import {
  StyledCardCell,
  StyledCardContainer,
  StyledCardRow,
  StyledCardText,
  StyledSamsungCard,
  StyledSamsungCardImageBox,
  StyledSamsungCardUserName
} from './style';
import './style.scss';

interface CardToPrintProps {
  userDetail: IUser;
}

export const CardToPrint = forwardRef<HTMLDivElement, CardToPrintProps>(({ userDetail }, ref) => {
  const image = useMemo(
    () => userDetail.userFileUrl || nfcCardIcons.emptyProfile,
    [userDetail.userFileUrl]
  );

  const { data: nations } = useGetNationList({
    data: {
      size: 1000
    }
  });
  const flagUrl = useMemo(
    () => nations?.find((nation) => nation.nationId === userDetail.nationId)?.flagUri,
    [nations, userDetail.nationId]
  );

  const data = [
    {
      label: 'Company',
      icon: nfcCardIcons.company,
      value: userDetail.companyName || TABLE_EMPTY_DATA
    },
    {
      label: 'Position',
      icon: nfcCardIcons.position,
      value: userDetail.designationName || TABLE_EMPTY_DATA
    },
    {
      label: 'Nationality',
      icon: nfcCardIcons.nationality,
      value: userDetail.nationName || TABLE_EMPTY_DATA,
      flagUrl: flagUrl ? `${import.meta.env.VITE_API_URL}${flagUrl}` : null
    },
    {
      label: 'Blood Type',
      icon: nfcCardIcons.bloodType,
      value: userDetail.bloodType || TABLE_EMPTY_DATA
    },
    {
      label: 'Training Date',
      icon: nfcCardIcons.trainingDate,
      value: userDetail.hsseInduction || TABLE_EMPTY_DATA
    }
  ];

  return (
    <StyledSamsungCard ref={ref}>
      <StyledSamsungCardImageBox>
        <img src={image} alt="ssp-card-image" />
      </StyledSamsungCardImageBox>

      <StyledSamsungCardUserName>
        <div>{userDetail.fullName || TABLE_EMPTY_DATA}</div>
      </StyledSamsungCardUserName>

      <StyledCardContainer>
        {data.map((item, index) => (
          <StyledCardRow key={index}>
            <StyledCardCell>
              <img src={item.icon} alt="아이콘" width={36} height={36} />
              <StyledCardText className="label">{item.label}</StyledCardText>
            </StyledCardCell>
            <StyledCardCell>
              <StyledCardText className="value">
                {item.value}
                {item?.flagUrl && (
                  <img
                    src={item.flagUrl}
                    width={44}
                    height={36}
                    alt="flag"
                    crossOrigin="anonymous"
                  />
                )}
              </StyledCardText>
            </StyledCardCell>
          </StyledCardRow>
        ))}
      </StyledCardContainer>
    </StyledSamsungCard>
  );
});

CardToPrint.displayName = 'CardToPrint';
